import {
  CompanyContactPerson,
  GetCompanyMemoResult,
  Status,
} from '../../../../types/api'
import { Action } from './type'

export type StatusPanelAction =
  | (Action & {
      type: 'OPEN_STATUS_PANEL'
    })
  | (Action & {
      type: 'CLOSE_STATUS_PANEL'
    })
  | (Action & {
      type: 'STORE_STATUS_PANEL_PAYLOAD'
    })

export const OPEN_STATUS_PANEL = 'OPEN_STATUS_PANEL'
export const CLOSE_STATUS_PANEL = 'CLOSE_STATUS_PANEL'
export const STORE_STATUS_PANEL_PAYLOAD = 'STORE_STATUS_PANEL_PAYLOAD'

export function openStatusPanel() {
  return { type: OPEN_STATUS_PANEL }
}

export function closeStatusPanel() {
  return { type: CLOSE_STATUS_PANEL }
}

export function storeStatusPanelPayload(
  companyId: string,
  companyMemo: GetCompanyMemoResult,
  contractPerson: CompanyContactPerson,
  status: Status
) {
  return {
    type: STORE_STATUS_PANEL_PAYLOAD,
    payload: {
      companyId: companyId,
      companyMemo: companyMemo,
      contractPerson: contractPerson,
      status: status,
    },
  }
}

export const statusPanelActions = {
  openStatusPanel,
  closeStatusPanel,
  storeStatusPanelPayload,
}
